(() => {
  if (window.timezSizeGuideEventsReady) return;
  window.timezSizeGuideEventsReady = true;

  const getDialog = (control) => {
    const wrapper = control.closest('[data-timez-size-guide]');
    return wrapper?.querySelector('[data-timez-size-guide-dialog]');
  };

  const setExpanded = (dialog, expanded) => {
    const wrapper = dialog.closest('[data-timez-size-guide]');
    const opener = wrapper?.querySelector('[data-size-guide-open]');
    opener?.setAttribute('aria-expanded', expanded ? 'true' : 'false');
  };

  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;

    const opener = event.target.closest('[data-size-guide-open]');
    if (opener) {
      const dialog = getDialog(opener);
      if (!(dialog instanceof HTMLDialogElement)) return;

      if (typeof dialog.showModal === 'function') {
        dialog.showModal();
      } else {
        dialog.setAttribute('open', '');
      }
      setExpanded(dialog, true);
      return;
    }

    const closeButton = event.target.closest('[data-size-guide-close]');
    if (closeButton) {
      const dialog = getDialog(closeButton);
      if (!(dialog instanceof HTMLDialogElement)) return;

      dialog.close();
      setExpanded(dialog, false);
      return;
    }

    if (event.target.matches('[data-timez-size-guide-dialog]')) {
      const dialog = event.target;
      dialog.close();
      setExpanded(dialog, false);
    }
  });

  document.addEventListener(
    'close',
    (event) => {
      if (!(event.target instanceof HTMLDialogElement)) return;
      if (!event.target.matches('[data-timez-size-guide-dialog]')) return;
      setExpanded(event.target, false);
    },
    true
  );
})();
